import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useCompany from '../hooks/useCompany';
import CustomNavigate from '../components/CustomNavigate';

export default function APIKeyModuleMiddleware({ children }) {
    const { activeCompany } = useCompany();

    if (!activeCompany) return <CustomNavigate to="/dashboard/home" />;

    const modules = activeCompany?.modules || [];

    const hasApiKeyModule = modules.some((module) => 
        typeof module === 'string' ? module === 'api_key_module' : module.slug === 'api_key_module'
    );

    if (!hasApiKeyModule) return <CustomNavigate to="/dashboard/home" />;

    return children;
}

APIKeyModuleMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};